import { render, staticRenderFns } from "./ResourceBlock.vue?vue&type=template&id=4aaae0c6&"
import script from "./ResourceBlock.vue?vue&type=script&lang=js&"
export * from "./ResourceBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports